import "jquery-ui/ui/widgets/slider";
import "selectric";
import "./modules/touch-punch.js";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.promise";

let common = require('./modules/common');
let tracking = require('./modules/tracking');
let LazyLoad = require('./modules/image');

let internals = {
    initSlider: function (Swiper) {
        new Swiper('#imagesSlider', {
            loop: false,
            lazy: {
                loadPrevNext: true,
            },
            slidesPerView: 5,
            spaceBetween: 20,
            navigation: {
                nextEl: '#imagesNext',
                prevEl: '#imagesPrev',
            },
            breakpoints: {
                767: {
                    slidesPerView: 2.5,
                    spaceBetween: 10
                },
                999: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1199: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        });
    }
};


// Filter logic from lyudi/store package
let productFilter = {};
let initializing = true;
let lastClick = undefined;

$('#productFilter').on('click', 'span.filter__param_show_all', function () {
    let target = $(this).data('target');
    $(this).addClass('filter__param_show_all--hidden');
    $(target).addClass('filter__list_collapse--open');
});

$('.popup-open').click(function () {
    let id = $(this).data('target');
    $(id).addClass('open');
    $('body').addClass('is-locked');
    return false;
});

$('.popup-close').click(function (e) {
    $(this).closest('.open').removeClass('open');
    $('body').removeClass('is-locked');
    if (e.defaultPrevented) {
        return false;
    }
});

$('.filter__range').each(function () {
    let $this = $(this);
    let input = $this.find('input[type=hidden]');
    let range = $this.find('.filter__range__bar');
    let min = +input.attr('data-from');
    let max = +input.attr('data-to');
    let minInput = $this.find('.range-min');
    let maxInput = $this.find('.range-max');

    range.slider({
        range: true,
        min: min,
        max: max,
        values: [min, max],
        create: function (event, ui) {
            minInput.val(min);
            maxInput.val(max);

            minInput.change(function () {
                if (+minInput.val() > +maxInput.val()) {
                    minInput.val(maxInput.val());
                }
                range.slider('values', 0, minInput.val());

                let value = '';

                if (minInput.val() > input.data('min')) {
                    value += minInput.val();
                } else {
                    value += '0';
                }
                value += ',';

                if (maxInput.val() < input.data('max')) {
                    value += maxInput.val();
                } else {
                    value += '0';
                }

                if (value === '0,0') {
                    value = '';
                }
                input.val(value).trigger('change');

            });

            maxInput.change(function () {
                if (+minInput.val() > +maxInput.val()) {
                    minInput.val(maxInput.val());
                }
                range.slider('values', 1, maxInput.val());

                let value = '';

                if (minInput.val() > input.data('min')) {
                    value += minInput.val();
                } else {
                    value += '0';
                }
                value += ',';

                if (maxInput.val() < input.data('max')) {
                    value += maxInput.val();
                } else {
                    value += '0';
                }

                if (value === '0,0') {
                    value = '';
                }
                input.val(value).trigger('change');
            });

        },
        slide: function (event, ui) {
            minInput.val(ui.values[0]);
            maxInput.val(ui.values[1]);

            let value = '';

            if (ui.values[0] > input.data('min')) {
                value += ui.values[0];
            } else {
                value += '0';
            }
            value += ',';

            if (ui.values[1] < input.data('max')) {
                value += ui.values[1];
            } else {
                value += '0';
            }

            if (value === '0,0') {
                value = '';
            }
            input.val(value);
        },
        stop: function (event, ui) {
            input.trigger('change');
        }
    });

});

let filter = $('#productFilter');

filter
    .on('change', 'input[type=checkbox]', onFilterChange)
    .on('change', 'input[type=radio]', onFilterChange)
    .on('change', 'input[type=hidden]', onFilterChange)
    .on('keyup paste', 'input[type=text]', onFilterChange)
    .on('click', 'a, button', function (e) {
        e.preventDefault();
        if ($(this).data('action') === 'clear') {
            lastClick = undefined;
            productFilter = {};
            getCount();
            $('#productFilter').trigger("reset");
            loadItems(null, true);
        } else if ($(this).data('action') === 'load') {
            loadItems(null, true);
        } else {
            window.location.href = getFilterQueryString();
        }
    });

filter.find('input[type=checkbox]').trigger('change');
filter.find('input[type=radio]').trigger('change');
filter.find('input[type=text]').trigger('paste');
initializing = false;

$('#sort').selectric({
    disableOnMobile: false,
    nativeOnMobile: false,
    onChange: function () {
        loadItems(null, true);
    }
});

$('#categoryItems').on('click', '#moreProducts', function (e) {
    e.preventDefault();
    loadItems($(this).data('page'));
}).on('click', 'a[data-action="to-page"]', function (e) {
    e.preventDefault();
    loadItems($(this).data('page'), true);
    $('body,html').animate({ scrollTop: 170}, 1100);
});

window.onpopstate = function (event) {
    if (event.state !== null) {
        productFilter = event.state.filter;
        loadItems(event.state.page);
    }
};

function onFilterChange() {
    lastClick = $(this);

    let newValue, oldValue, checked;
    let data = $(this).parent().data('filter');

    if (data === undefined) data = $(this).data('filter');

    if (data === undefined) return;

    let filterParams = data.split(',');

    let filterName = filterParams[0];
    let filterType = filterParams[1];

    switch (filterType) {
        case 'value':
            if (filterParams[2] === '0') {
                if ($(this).prop('checked')) {
                    newValue = filterParams[2] + ',';
                } else {
                    newValue = '';
                }
            } else {
                newValue = $('#f_' + filterName).val();
            }
            oldValue = productFilter[filterName] || '';
            if (newValue == oldValue) return;

            if ((newValue == '') || (newValue == ',')) {
                delete productFilter[filterName];
            } else {
                productFilter[filterName] = newValue;
            }
            break;
        case "list":
            newValue = filterParams[2];
            checked = $(this).prop('checked');

            if (checked) {
                if (productFilter[filterName] === undefined) {
                    productFilter[filterName] = newValue;
                } else {
                    oldValue = productFilter[filterName].split(',');

                    if (oldValue.indexOf(newValue) >= 0) return;
                    productFilter[filterName] += ',' + newValue;
                }
            } else {
                if (productFilter[filterName] !== undefined) {
                    oldValue = productFilter[filterName].split(',');
                    let index = oldValue.indexOf(newValue);
                    if (index === -1) return;
                    oldValue.splice(index, 1);
                    productFilter[filterName] = oldValue.join(',');
                    if (productFilter[filterName] === '' || productFilter[filterName] === undefined) {
                        delete productFilter[filterName];
                    }
                }
            }
            break;
        case "other":
            filterName = 'other_' + filterName;
            newValue = filterParams[2];
            checked = $(this).prop('checked');
            if (checked) {
                productFilter[filterName] = newValue;
            } else {
                if (productFilter[filterName] !== undefined) {
                    delete productFilter[filterName];
                }
            }
            break;
        case "nlist":
            filterName = 'nlist_' + filterName;
            newValue = filterParams[2];
            checked = $(this).prop('checked');
            if (checked) {
                productFilter[filterName] = newValue;
            } else {
                if (productFilter[filterName] !== undefined) {
                    delete productFilter[filterName];
                }
            }
            break;
        case "string":
            if ($(this).val() != '') {
                productFilter[filterName] = $(this).val();
            } else {
                delete productFilter[filterName];
            }
            break;
        case 'boolean':
            checked = $(this).val();
            let type = $(this).attr('type');

            if (checked === 'toggle') {
                if ($(this).prop('checked')) {
                    if (productFilter[filterName] == 1) return;
                    productFilter[filterName] = 1;
                } else {
                    delete productFilter[filterName];
                }
            } else {
                if (checked == 1) {
                    if ($(this).prop('checked')) {
                        $('#property_' + filterName + '_false').prop('checked', false)
                            .parent().removeClass('active');
                        if (productFilter[filterName] == 1) return;
                        productFilter[filterName] = 1;
                    } else {
                        if (productFilter[filterName] == 1) delete productFilter[filterName];
                    }
                } else {
                    if ($(this).prop('checked')) {
                        $('#property_' + filterName + '_true').prop('checked', false)
                            .parent().removeClass('active');
                        if (productFilter[filterName] == 0) return;
                        productFilter[filterName] = 0;
                    } else {
                        if (productFilter[filterName] == 0) delete productFilter[filterName];
                    }
                }
            }
            break;
        case 'availability':
            let val = $('#productFilter').find('[name=f_availability]:checked').val();
            if (val !== 'all') {
                productFilter[filterName] = val;
            } else {
                delete productFilter[filterName];
            }
            break;
    }

    if (!initializing) {
        getCount();
    }

    $('#filter div.param').find('a').removeClass('active');
    $('#filter div.param').has('input:checked').find('a').addClass('active');
}

function getFilterQueryString(ajax, page, mode) {
    let sortSelector = $('#sort > option:selected');

    if (sortSelector.length && sortSelector.data('sort') !== 'popular') {
        productFilter['s'] = sortSelector.data('sort');
        productFilter['d'] = sortSelector.data('direction');
    } else {
        delete productFilter['s'];
        delete productFilter['d'];
    }

    let qs = [];
    $.each(productFilter, function (index, value) {
        if ((parseInt(index, 10) == index) || (index.lastIndexOf('other', 0) === 0) || (index.lastIndexOf('nlist', 0) === 0)) {
            qs.push(encodeURIComponent('filter[' + index + ']') + '=' + encodeURIComponent(value));
        } else {
            qs.push(encodeURIComponent(index) + "=" + encodeURIComponent(value));
        }
    });

    if ($('#query').val() !== '' && window.location.pathname === '/search') {
        qs.push('q=' + $('#query').val());
    }

    if (page) {
        qs.push("page=" + page);
    }
    if (qs.length === 0) {
        if (ajax) {
            return '//' + location.host + location.pathname + '?ajax=1';
        }
        return '//' + location.host + location.pathname;
    }
    qs.sort();
    if (ajax) {
        qs.push("mode=" + mode);
        qs.push("ajax=1");
    }
    return "?" + qs.join('&');
}

function getCount(page) {
    $.ajax({
        method: "GET",
        url: getFilterQueryString(true, page, 'count'),
        dataType: 'json',
        success: function (data) {
            $.each(data.facets, function (id, count) {
                let element = $('#' + id);
                element.find('.filter__filtered').html('(' + count.filtered + ')');
                if (count.filtered == '0') {
                    element.find('input').prop('disabled', true);
                } else {
                    element.find('input').prop('disabled', false);
                }
            });

            if (lastClick !== undefined && lastClick.length) {
                if (window.innerWidth >= 1000) {
                    $('#filterPointer').appendTo(lastClick.parent()).addClass('open');
                }
                $('#filterPointer').find('span').html(data.total);
            }
        }
    });
}

function loadItems(page, replace) {
    let items = $('#categoryItems');
    items.addClass('loading');

    $.ajax({
        method: "GET",
        url: getFilterQueryString(true, page, 'query'),
        dataType: 'json',
        success: function (data) {
            if (replace) {
                items.empty();
            } else {
                document.getElementById('pagination').remove();
            }
            items.removeClass('loading');
            items.append(data.html);
            document.title = data.title;
            LazyLoad.init();
            $('#filterPointer').removeClass('open');
            $('.more > .load-indicator').addClass('hidden');
            if (replace && window.innerWidth >= 1000) {
                $('html, body').animate({
                    scrollTop: items.offset().top - 40
                }, 1000);
            }

            sortFilters();
        }
    });

    window.history.pushState({filter: productFilter, page: page}, "Search", getFilterQueryString(false, page));
}

tracking.trackProductList($('.product-list-item'));

if (document.getElementById('imagesSlider')) {
    import(
        /* webpackChunkName: "swiper" */
        './modules/swiper').then(function (module) {
        internals.initSlider(module.default);
    }, function (e) {
        console.log('Unable to load swiper library' + e.message);
        throw new Error('Unable to load swiper library' + e.message);
    });
}

function sortFilters() {
    let filters = document.querySelectorAll('.filter__list');
    filters.forEach(function (filter) {
        let items = $(filter).find('li').sort(function (a, b) {

            let aChecked = $(a).find('input').prop('checked') ? 0 : 1000;
            let bChecked = $(b).find('input').prop('checked') ? 0 : 1000;

            if ($(a).find('input').prop('disabled')) {
                aChecked = 2000;
            }

            if ($(b).find('input').prop('disabled')) {
                bChecked = 2000;
            }

            return (aChecked + parseInt(a.getAttribute('data-sort'))) > (bChecked + parseInt(b.getAttribute('data-sort'))) ? 1 : -1;
        });
        $(filter).append(items);
    });
}